// src/main.js
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueHead from 'vue-head'
import VueChart from 'vue-chartjs'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

import cognito from './cognito'      // インスタンスを import
import store from './store'
import Ads from 'vue-google-adsense'


Vue.config.productionTip = false
Vue.use(VueAxios, axios)
Vue.use(VueHead)
Vue.use(VueChart)
Vue.use(Loading)
Vue.use(require('vue-script2'))

Vue.use(Ads.Adsense)
Vue.use(Ads.InArticleAdsense)
Vue.use(Ads.InFeedAdsense)
//Vue.use(Ads.AutoAdsense, { adClient: 'ca-pub-3076785709839281' })


/* ====== SPA⇄Nuxt ライトなログイン状態ブリッジ ====== */
const AUTH_BRIDGE_KEY = 'bn_auth_state'

function writeAuthState(session) {
  try {
    const user = store.getters.user || {}
    const idToken = session?.getIdToken?.()?.getJwtToken?.()
    let exp = null, iat = null
    if (idToken) {
      try {
        const payload = JSON.parse(atob(idToken.split('.')[1] || ''))
        exp = payload?.exp ?? null
        iat = payload?.iat ?? null
      } catch (e) {
        // no-empty 回避のため no-op 明示
        void e
      }
    }
    const data = {
      signedIn: !!session,
      nickname: user?.nickname || user?.name || null,
      exp, iat
    }
    localStorage.setItem(AUTH_BRIDGE_KEY, JSON.stringify(data))
  } catch (e) {
    void e
    localStorage.removeItem(AUTH_BRIDGE_KEY)
  }
}
function clearAuthState() {
  localStorage.removeItem(AUTH_BRIDGE_KEY)
}

/* ====== cognito インスタンスのメソッドを安全にパッチ ====== */
if (cognito && typeof cognito.login === 'function') {
  const _login = cognito.login.bind(cognito)
  cognito.login = (...args) =>
    _login(...args)
      .then((res) =>
        cognito.isAuthenticated()
          .then((s) => { writeAuthState(s); return res })
          .catch((e) => { void e; clearAuthState(); return res })
      )
      .catch((e) => { clearAuthState(); throw e })
}
if (cognito && typeof cognito.logout === 'function') {
  const _logout = cognito.logout.bind(cognito)
  cognito.logout = (...args) => { clearAuthState(); return _logout(...args) }
}

/* ====== Vue アプリ起動（未使用変数を作らない） ====== */
new Vue({
  router,
  store,
  cognito,
  render: h => h(App),
}).$mount('#app')

/* 起動時に現在のログイン状態を同期 */
if (cognito && typeof cognito.isAuthenticated === 'function') {
  cognito.isAuthenticated()
    .then((s) => writeAuthState(s))
    .catch((e) => { void e; clearAuthState() })
}

/* （任意）ニュース Lambda へ Authorization を付与したい場合の雛形
const NEWS_ORIGIN = process.env.VUE_APP_NEWS_API_ORIGIN
axios.interceptors.request.use(async (config) => {
  if (NEWS_ORIGIN && String(config.url || '').startsWith(NEWS_ORIGIN)) {
    try {
      const session = await cognito.isAuthenticated()
      const token = session?.getIdToken?.()?.getJwtToken?.()
      if (token) config.headers.Authorization = `Bearer ${token}`
    } catch (e) { void e }
  }
  return config
})
*/